<template>
  <div class="addForm">
    <el-form
      :model="scheduleForm"
      :rules="scheduleFormRule"
      ref="scheduleForm"
      class="drawer-main"
    >
      <el-form-item label="日程名称" prop="title">
        <el-input
          v-model="scheduleForm.title" placeholder="请输入日程名称" :maxlength="64"></el-input>
      </el-form-item>
      <el-form-item label="所属日历" prop="calendarId">
        <el-select
          v-model="scheduleForm.calendarId" class="W100P">
          <el-option
            v-for="(item,index) in personalCalendar" :key="index" :label="item.name" :value="item.id" style="width: 100%">
            <span>{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日程时间" prop="startDate">
        <br>
        <div>
          <el-radio v-model="scheduleForm.isWholeDay" label="0">非全天</el-radio>
          <el-radio v-model="scheduleForm.isWholeDay" label="1">全天</el-radio>
        </div>
        <div style="display: flex; margin-bottom: 10px;">
          <el-date-picker
            style="flex: 1;" v-model="scheduleForm.startDate" :type="scheduleForm.isWholeDay === '1' ? 'date': 'datetime'"
            placeholder="选择日期时间" default-time="08:00:00" value-format="yyyy-MM-dd HH:mm:ss" @change="endDateJudge"
          ></el-date-picker>
          <span style="margin: 0 10px;">-</span>
          <el-date-picker
            style="flex: 1;"
            v-model="scheduleForm.endDate" :type="scheduleForm.isWholeDay === '1' ? 'date': 'datetime'"
            placeholder="选择日期时间" default-time="08:00:00" value-format="yyyy-MM-dd HH:mm:ss" @change="endDateJudge"
          ></el-date-picker>
        </div>
        <div>
          <el-select v-model="scheduleForm.repeatType" style="flex: 1;">
            <el-option v-for="(item,index) in repeatTypeOptions" :label="item.label" :value="item.value" :key="index">{{item.label}}</el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item
        label="周期设置" v-if="scheduleForm.repeatType === '06'">
        <div style="display: flex">
          <span style="width: 30px">每隔</span>
          <el-input v-model="scheduleForm.repeatCycleCount" style="flex:1"></el-input>
          <el-select
            v-model="scheduleForm.repeatCycleType" placeholder="请选择" style="width: 100px">
            <el-option
              v-for="item in repeatDiyOptions" :key="item.value" :label="item.label" :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="周期结束" v-if="scheduleForm.repeatType !== '01'">
        <div>
          <el-radio v-model="scheduleForm.repeatEndRadio" label="1">一直有效</el-radio>
        </div>
        <div>
          <el-radio v-model="scheduleForm.repeatEndRadio" label="2">
            <el-input v-model="repeatNum"></el-input>次后结束</el-radio>
        </div>
        <div style="margin-top: 10px">
          <el-radio v-model="scheduleForm.repeatEndRadio" label="3">
            结束日期
            <el-date-picker
              v-model="repeatEndTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-radio>
        </div>
      </el-form-item>
      <el-form-item label="日程地点">
        <el-input
          v-model="scheduleForm.address" placeholder="请输入地点"
        ></el-input>
      </el-form-item>
      <el-form-item label="提醒" v-if="scheduleForm.scheduleType === '1'" placeholder="请输入提醒方式">
        <el-select
          v-model="scheduleForm.remindDate" class="W100P">
          <el-option
            v-for="(item,index) in remindOptions"
            :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日程描述" prop="remark">
        <el-input
          type="textarea" placeholder="请输入说明，300个字以内" v-model="scheduleForm.remark"
          maxlength="300" show-word-limit :autosize="{ minRows: 4, maxRows: 10 }"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="drawer-footer">
      <el-button round @click="cancel" size="medium">取消</el-button>
      <el-button type="primary" round @click="save" size="medium" :loading="btnLoading">确定</el-button>
    </div>
  </div>
</template>
<script>
  import {insertSchedule, getPersonlCalendar} from "@/api/calendar";
  import {remindOptions, repeatDiyOptions, repeatTypeOptions} from "@/utils/enumeration"
  export default {
    data() {
      return {
        // 日程表单
        scheduleForm: {
          timezone: "GMT+8:00 - 中国标准时间",
          repeatType: "01",
          isWholeDay: "0",
          address: "",
          remark: "",
          repeatCycleType: '2',
          repeatCycleCount: "",
          repeatEndType: "",
          repeatEndRadio: "1",
          remindDate: "",
          startDate: "",
          endDate: "",
          scheduleType: '1' // 日程类型分为个人日程与公共日程，个人日程为1， 公共日程为0
        },
        // 日程表单规则
        scheduleFormRule: {
          title: [{required: true, message: "请输入日程名称", trigger: "blur"}],
          calendarId: [
            {required: true, message: "请选择所属日历", trigger: "blur"}
          ],
          startDate: [
            {required: true, message: "请选择日程时间", trigger: "choose"}
          ]
        },
        // 个人日历
        personalCalendar: [],
        // 提醒方式枚举
        remindOptions: remindOptions,
        // 自定义重复方式单位列表
        repeatDiyOptions: repeatDiyOptions,
        repeatTypeOptions: repeatTypeOptions,
        btnLoading: false,
        // 重复结束次数
        repeatNum: 0,
        // 重复结束时间
        repeatEndTime: ""
      };
    },
    props: {
      visible:{
        default: false
      }
    },
    watch: {
      // 抽屉关闭验证结果清除，数据初始化
      visible(val) {
        if(!val) this.initData();
        this.$refs.scheduleForm.resetFields();
      }
    },
    created() {
      this.getPersonlCalendar();
    },
    methods: {
      // 数据初始化
      initData(){
        this.scheduleForm.timezone="GMT+8:00 - 中国标准时间";
        this.scheduleForm.repeatType="01";
        this.scheduleForm.isWholeDay="0";
        this.scheduleForm.address="";
        this.scheduleForm.remark="";
        this.scheduleForm.repeatCycleType="2";
        this.scheduleForm.repeatCycleCount="";
        this.scheduleForm.repeatEndType="";
        this.scheduleForm.repeatEndRadio="1";
        this.scheduleForm.remindDate="";
        this.scheduleForm.scheduleType="1";
        this.scheduleForm.startDate = "";
        this.scheduleForm.endDate = "";
        this.repeatNum = 0;
        this.repeatEndTime = "";
      },
      // 获取个人日历
      async getPersonlCalendar() {
        try {
          let res = await getPersonlCalendar();
          if (res.code !== 0) {
            this.$message.error("获取个人日历失败！");
            return false;
          }
          this.personalCalendar = res.data;
        } catch (e) {
          this.$message.error("获取个人日历失败！");
        }
      },
      // 添加日程结束日期判断
      endDateJudge() {
        if (
          new Date(this.scheduleForm.endDate).getTime() <
          new Date(this.scheduleForm.startDate).getTime()
        ) {
          this.$set(this.scheduleForm, "endDate", "");
          this.$message({
            message: "结束时间不能早于开始时间",
            type: "warning"
          });
        }
      },
      cancel() {
        this.$emit("closeDrawer", "cancel");
      },
      save() {
        this.$refs.scheduleForm.validate(async valid => {
          if (!valid) return false;
          if (!this.scheduleForm.startDate) {
            this.$message.error("请选择开始时间");
            return;
          }
          if (!this.scheduleForm.endDate) {
            this.$message.error("请选择结束时间");
            return;
          }
          // 全天对日期格式做处理
          if (this.scheduleForm.isWholeDay === '1') {
            this.scheduleForm.startDate = this.scheduleForm.startDate.substring(0, 10) + ' 00:00:00';
            this.scheduleForm.endDate = this.scheduleForm.endDate.substring(0, 10) + ' 23:59:59';
          }
          // 当设置日程重复时，获取日程重复的结束时间
          if (this.scheduleForm.repeatType !== '01') {
            this.getRepeatEndType();
          }
          try {
            this.btnLoading = true;
            let res = await insertSchedule(this.scheduleForm);
            this.btnLoading = false;
            if (res.code !== 0) {
              this.$message.error("添加日程失败！");
              return false;
            }
            this.$message.success(res.message);
            this.$emit("closeDrawer", "save")
          } catch (err) {
            this.$message.error(err.message);
            this.btnLoading = false;
          }
        });
      },
      // 获取日程重复的结束时间
      getRepeatEndType() {
        switch (this.scheduleForm.repeatEndRadio) {
          case "1":
            this.scheduleForm.repeatEndType = "";
            break;
          case "2":
            this.scheduleForm.repeatEndType = this.repeatNum;
            break;
          case "3":
            this.scheduleForm.repeatEndType = this.repeatEndTime;
            break;
        }
      },
    }
  };


</script>
<style lang="scss">
  .addForm {
    height: calc(100vh - 102px);
    display: flex;
    flex-direction: column;
    .drawer-main {
      flex:1;
      overflow-y: scroll;
    }
    .drawer-footer {
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;

    }
  }
  .addForm .el-select > .el-input {
    width: 100%;
  }
</style>